import { gql } from '@apollo/client';

export const GET_INSTITUTION_TYPE = gql`
  query GetInstitutionType($institutionId: ID) {
    institutionType: getInstitutionType(institutionId: $institutionId) {
      id
      name
    }
  }
`;
